<template>
  <div v-html="errorContent">
  </div>
</template>

<script>
// @ is an alias to /src
import Common from '@/common.js'

export default {
  name: 'PostError',
  components: {
  },
   mounted:function(){
      this.loadOnMount();
  },
   data:function(){
      return { isMobile: false, errorContent: '' };
  },
  methods:{

      onResize: function() {
        
      this.isMobile = window.innerWidth < 600;
      
    },
      loadOnMount: function() {
        
        Common.stopAjaxLoader();
        //alert(Common.errorContent);
        this.errorContent = Common.errorContent;
          
    }

  }
  
}
</script>
